export default "__VITE_ASSET__EUGf6BHP__"